// extracted by mini-css-extract-plugin
export var approve_message = "registr_form-module--approve_message--p+I2G";
export var choosed_role = "registr_form-module--choosed_role--1+Uo3";
export var chosed_role = "registr_form-module--chosed_role--0uzA1";
export var container_phrase = "registr_form-module--container_phrase--5V34I";
export var modal_button = "registr_form-module--modal_button--atH3Z";
export var resend_description = "registr_form-module--resend_description--GdIPi";
export var resend_img = "registr_form-module--resend_img--I03YN";
export var resend_title = "registr_form-module--resend_title--OJgv7";
export var role_input = "registr_form-module--role_input--J-f8m";
export var role_label = "registr_form-module--role_label--V7VeW";
export var role_wrapper = "registr_form-module--role_wrapper--fMAAu";
export var social_btn = "registr_form-module--social_btn--r10RT";
export var social_btn__apple = "registr_form-module--social_btn__apple--ga5Yr";
export var social_btn__fb = "registr_form-module--social_btn__fb--qDaPw";
export var social_btn__google = "registr_form-module--social_btn__google--PhE5p";
export var social_links_wrap = "registr_form-module--social_links_wrap--ekYoh";